import { NavListContext } from "App";
import { Toast } from "antd-mobile";
import { useContext, useEffect, useState } from "react";

const Top2Nav = (data: { onClick: (key: string) => void }) => {
  const navList = useContext(NavListContext).navList;
  const [activeKey, setActiveKey] = useState(navList.top2TermNow?.termUuid);

  useEffect(() => {
    // console.log("top2TermNow", navList.top2TermNow.termUuid);
    setActiveKey(navList.top2TermNow?.termUuid);
  }, [navList.top2TermNow?.termUuid]);

  return (
    <>
      <div className=" flex p-2 overflow-x-auto bg-slate-50 border-b-2 bg-opacity-95 rounded-bl-2xl rounded-br-2xl shadow-2xl">
        {navList.top2TermList.map((item, index) => (
          <div
            key={activeKey + "_" + index}
            className={[
              "text-nowrap text-base px-1 mr-2 transition transition-200",
              item.termUuid === activeKey
                ? "  text-orange-400 font-bold border-b-4 border-orange-400"
                : "  border-b-4 border-transparent",
            ].join(" ")}
            onClick={() => {
              // TODO 禁止点击, 有数据后再开放
              // Toast.clear();
              // Toast.show("前方区域, 请稍后探索吧 ❤");
              // return;
              data.onClick(item.termUuid);
              setActiveKey(item.termUuid);
            }}
          >
            {item.termName}
          </div>
        ))}
      </div>
    </>
  );
};

export default Top2Nav;
